module.exports = __webpack_public_path__ + "img/biometric-logo.b0a8cb60.svg";